'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shapeClassNames = {
  auto: 'dp-Icon',
  round: 'dp-Icon dp-Icon--Round'
};

/**
 * @param {string} [align]
 * @param {string} [className]
 * @return {*}
 * @constructor
 */
/**
 * @param {string} src
 * @param {string} [shape]
 * @param {string} [className]
 * @return {*}
 * @constructor
 */
var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      shape = _ref.shape,
      className = _ref.className;
  return _react2.default.createElement(
    'i',
    { className: (0, _classnames2.default)(shapeClassNames[shape], className) },
    _react2.default.createElement('img', { src: src, alt: '' })
  );
};

Avatar.propTypes = {

  className: _propTypes2.default.string,

  src: _propTypes2.default.string.isRequired,

  shape: _propTypes2.default.oneOf(['round', 'auto'])
};

Avatar.defaultProps = {
  shape: "auto"
};

exports.default = Avatar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Image/Avatar.js
// module id = 366
// module chunks = 0